/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IParamedic } from 'app/shared/model/paramedic.model';
import { IAppointmentStatus } from 'app/shared/model/appointment-status.model';
import { IHospitalPatientAttribute } from 'app/shared/model/hospital-patient-attribute.model';
import { DiscountType } from 'app/shared/model/enumerations/discount-type.model';
import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IVolunteerVisits {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  visitNotes?: string | null;
  capturedDtm?: number;
  visitDate?: number;
  paidAmount?: number | null;
  discount?: number | null;
  discountType?: keyof typeof DiscountType | null;
  paymentMethod?: keyof typeof PaymentMethod | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  transactionRef?: string | null;
  appliedCategoryCode?: string | null;
  glucoUser?: IGlucoUser | null;
  paramedic?: IParamedic | null;
  appointmentStatus?: IAppointmentStatus | null;
  appliedCategory?: IHospitalPatientAttribute | null;
}

export const defaultValue: Readonly<IVolunteerVisits> = {
  active: false,
};
